// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1Xn_z","approved":"Status_approved__2_GHK","rejected":"Status_rejected__3tiYv","expired":"Status_expired__3EbhX","label":"Status_label__1sM7-"};